import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MATRIX_PERMISSIONS, EXTRA_PERMISSIONS, PERMISSION_LABELS } from '../../../../shared/utils/agency-rbac';

const ORDER: string[] = [...MATRIX_PERMISSIONS, ...EXTRA_PERMISSIONS];

@Component({
  selector: 'app-details-user',
  templateUrl: './details-user.component.html',
  styleUrl: './details-user.component.scss'
})
export class DetailsUserComponent {
  constructor(
    public dialogRef: MatDialogRef<DetailsUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  get permissionLabels(): string[] {
    const granted: string[] = this.data?.permissions ?? [];
    // Ordre du PDF client ; un droit inconnu du front reste affiché tel quel.
    const sorted = [...granted].sort((a, b) => {
      const ia = ORDER.indexOf(a), ib = ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    return sorted.map((p: string) => PERMISSION_LABELS[p] ?? p);
  }

  format(value?: string): string {
    if (!value) {
      return 'N/A';
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return value;
    }
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} à ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}
